module.exports = __webpack_public_path__ + "img/horizontal_7_7_4.b9b74a45.png";